import * as React from "react";
import {graphql} from "gatsby";
import PlatformPage from "../../page-components-new/platform/platform-page";
import platform from "../../data/platforms/woocommerce.json";

const WoocommercePage = () => <PlatformPage platform={platform}/>;

export default WoocommercePage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
